import * as userActions from 'actions/user';

const initialState = {
  id: '',
  imgSrc: '',
  displayName: '',
  groups: {},
  email: '',
  account: null,
  fetched: false,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case userActions.RECEIVE_USER_INFO:
      return {
        ...state,
        ...action.user,
        fetched: true,
      };

    case userActions.SET_USER_ACCOUNT:
      return {
        ...state,
        ...action.user,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js